
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    color: {
      type: String,
      default: 'black',
    },
    size: {
      type: [String, Number],
      default: 64,
    },
  },
});
